import type { CSSProperties } from 'react';

export interface IRadioContext {
  value: any;
  onTabClick: (value: any, e: React.MouseEvent<HTMLDivElement>) => void;
  size: RadioTabSize;
}

export type RadioTabSize = 'small' | 'default' | 'middle' | 'large';
export interface RadioTabsProps {
  children: React.ReactNode;
  defaultValue: any;
  scrollable?: boolean;
  value?: any;
  className?: string;
  style?: CSSProperties;
  onChange?: (value: any) => void;
  size?: RadioTabSize;
  containerStyle?: CSSProperties;
  sliderClassName?: string;
  sliderStyle?: CSSProperties;
  id?: string;
  onMouseDown?: React.MouseEventHandler;
  availableWidth?: number;
  disabled?: boolean;
  disabledTip?: string;
  tabGap?: number;
  type?: 'plain';
}

export interface RadioTabProps {
  children: React.ReactNode | null | string;
  value: any;
  className?: string;
  style?: CSSProperties;
  disabled?: boolean;
  scrollable?: boolean;
  isActive?: boolean;
}

export const RadioTabDisplayName = 'RadioTab';
